module.exports = __webpack_public_path__ + "img/settings-sidebar-act.e2970886.svg";